/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './joinLink.defs'
export { main as default } from './joinLink.defs'
